import { useEffect, useContext, useState, useMemo, useRef } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import ReportListController from '../../controllers/report/ReportListController';
import { useNavigate } from 'react-router-dom';

import GbitTable from '../../components/tableComponents/GbitTable';
import SelectEnt from '../../components/selectComponents/SelectEnt';

const ReportList = () => {
  useEffect(() => {
    document.title = '유해요인조사보고서';
  }, []);
  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);

  const tableRef = useRef(null);
  const [searchParam, setSearchParam] = useState({
    entSn: store.entSn,
    pageSize: 10,
  });
  const [dataList, setDataList] = useState([]);
  const navigate = useNavigate(); // navigate 함수를 가져옴

  const controller = useMemo(() => {
    return new ReportListController(
      store,
      modalService,
      validateService,
      [tableRef],
      [searchParam, setSearchParam],
      {
        dataList,
        setDataList,
      },
      navigate // navigate 함수를 전달
    );
  }, [store, modalService, validateService]);

  useEffect(() => {
    controller.init();
  }, []);

  useEffect(() => {}, [searchParam]);

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">유해요인조사보고서</h2>
      </div>
      {store.authrtId === 'ADMIN' && (
        <div className="tbl-wrap">
          <p className="tbl-msg">
            <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
          </p>
          <table className="tbl data row">
            <colgroup>
              <col />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">
                  기업<em className="star-require">*</em>
                </th>
                <td>
                  <div className="input-group">
                    <SelectEnt
                      model="entSn"
                      valueObj={searchParam}
                      valueChange={(model, value) => {
                        controller.searchParamChange(model, value);
                      }}
                    />
                    <button
                      type="button"
                      className="btn md primary"
                      onClick={() => controller.fnSearch()}
                    >
                      조회
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      <div className="tbl-wrap">
        <GbitTable
          ref={tableRef}
          tableName="surveyListPage"
          headerList={controller.headerList}
          bodyList={dataList}
          onCellClick={controller.tableCellClick.bind(controller)}
          pageNow={searchParam?.currentPage}
          pageSize={searchParam?.pageSize}
          pageChange={value =>
            controller.searchParamChange('currentPage', value)
          }
          dataOption={controller.dataOption}
        />
      </div>
    </>
  );
};

export default ReportList;
